/** CoreUI `.header-fixed .app-header` stacking layer — panel must stay below it. */
export const APP_HEADER_FIXED_Z_INDEX = 1020;

/** Below the fixed header (1020) and sidebar (1019), above page content. */
export const SITE_PICKER_PANEL_Z_INDEX = 1010;

export const SITE_PICKER_SAFE_GAP = 8;
export const SITE_PICKER_DEFAULT_HEADER_OFFSET = 55;

export interface SitePickerFieldRect {
  top: number;
  bottom: number;
  left: number;
  width: number;
}

export interface SitePickerPanelPositionInput {
  fieldRect: SitePickerFieldRect;
  viewportWidth: number;
  viewportHeight: number;
  /** Bottom edge of the fixed header in viewport coordinates. */
  headerOffset?: number;
}

export interface SitePickerPanelPositionResult {
  style: {
    position: string;
    top: string;
    left: string;
    width: string;
    zIndex: string;
    maxHeight: string;
  };
  twoColumns: boolean;
}

export function computeSitePickerPanelPosition(
  input: SitePickerPanelPositionInput,
): SitePickerPanelPositionResult {
  const safeGap = SITE_PICKER_SAFE_GAP;
  const headerOffset = input.headerOffset ?? SITE_PICKER_DEFAULT_HEADER_OFFSET;
  const { fieldRect, viewportWidth, viewportHeight } = input;

  const maxAllowedWidth = viewportWidth - safeGap * 2;
  const panelWidth = Math.min(Math.max(520, Math.round(fieldRect.width)), 640, maxAllowedWidth);
  const clampedLeft = Math.max(safeGap, Math.min(fieldRect.left, viewportWidth - panelWidth - safeGap));
  const preferredTop = fieldRect.bottom + 6;
  const top = Math.max(preferredTop, headerOffset + safeGap);
  const maxHeight = Math.max(220, viewportHeight - top - safeGap);

  return {
    twoColumns: panelWidth >= 440,
    style: {
      position: "fixed",
      top: `${top}px`,
      left: `${clampedLeft}px`,
      width: `${panelWidth}px`,
      zIndex: String(SITE_PICKER_PANEL_Z_INDEX),
      maxHeight: `${Math.min(460, Math.round(maxHeight))}px`,
    },
  };
}
